module.exports = "<router-outlet></router-outlet>\r\n\r\n<app-chat-detail-modal></app-chat-detail-modal>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main